import { BlankHeader, ContactForm } from "../../components/website/Utility";
import '../../assets/css/views/contact.css';

export default function Contact() {
  return (
    <>
      <BlankHeader heading="CONTACT" />
      <ContactForm 
        heading="Want to get in touch?" 
        body="Please feel free to reach out to us regarding questions about pricing, features, or technical issues with the application at trevor@amplifyloyalty.com. You can also access our chat using the blue chatbox in the bottom right corner." 
        consume={true}
        demo={true}
      />
    </>
  )
}